import { SkillSet, SkillSetLevel, SkillLevelUpdatePayload } from 'src/feature/skill-assessment/model/skill-assessment-model'
import { updateSkillWithLevels } from 'src/feature/skill-assessment/api/skill-assessment-api'

/**
 * Saves skill updates to the backend and updates local store
 */
export const saveSkillUpdates = async (
  currentSkill: SkillSet,
  editedSkillName: string,
  editedSkillHint: string,
  editedDescriptions: Record<string, string>,
  sortedLevels: SkillSetLevel[],
): Promise<void> => {
  // Build level updates - only include changed descriptions
  const levelUpdates = sortedLevels
    .map((level) => {
      const newDescription = editedDescriptions[level.id]

      if (newDescription && level.setLevelDescription !== newDescription) {
        return {
          setLevelId: level.id,
          setLevelDescription: newDescription,
        }
      }

      return null
    })
    .filter((update): update is { setLevelId: string; setLevelDescription: string } => update !== null)

  const skillUpdate: SkillLevelUpdatePayload = {
    setId: currentSkill.id,
    levelUpdates,
  }

  // Add name if changed
  if (editedSkillName !== currentSkill.setName) {
    skillUpdate.setName = editedSkillName.trim()
  }

  // Add hint if changed
  if (editedSkillHint !== currentSkill.setHint) {
    skillUpdate.setHint = editedSkillHint.trim()
  }

  // Only call API if there are changes
  const hasChanges = levelUpdates.length > 0 || skillUpdate.setName !== undefined || skillUpdate.setHint !== undefined

  if (!hasChanges) {
    return
  }

  // Save to backend
  await updateSkillWithLevels(skillUpdate)

  // Update local state
  sortedLevels.forEach((level) => {
    const newDescription = editedDescriptions[level.id]

    if (newDescription) {
      level.setLevelDescription = newDescription
    }
  })

  if (skillUpdate.setName !== undefined) {
    currentSkill.setName = editedSkillName.trim()
  }

  if (skillUpdate.setHint !== undefined) {
    currentSkill.setHint = editedSkillHint.trim()
  }
}
